import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getPostState = (state: RootState) => state.post;

export const selectRoomPosts = createSelector(
  [getPostState],
  (postState) => postState.roomPosts.data
);

export const selectRoomPostsError = createSelector(
  [getPostState],
  (postState) => postState.roomPostsError
);

export const selectHasMoreRoomPosts = createSelector(
  [getPostState],
  (postState) => Boolean(postState.roomPosts?.xMsContinuationToken)
);

export const selectRoomPostsContinuationToken = createSelector(
  [getPostState],
  (postState) => postState.roomPosts?.xMsContinuationToken
);

export const selectLoadingPosts = createSelector(
  [getPostState],
  (postState) => postState.loadingPosts
);

export const selectLoadingCreateEditPost = createSelector(
  [getPostState],
  (postState) => postState.loadingCreateEditPost
);

export const selectCreateEditPostError = createSelector(
  [getPostState],
  (postState) => postState.createEditPostError
);

export const selectFeedPosts = createSelector(
  [getPostState],
  (postState) => postState.feedPosts?.data
);

export const selectFeedPostsError = createSelector(
  [getPostState],
  (postState) => postState.feedPostsError
);

export const selectLoadingFeedPosts = createSelector(
  [getPostState],
  (postState) => postState.loadingFeedPosts
);

export const selectHasMoreFeedPosts = createSelector(
  [getPostState],
  (postState) => Boolean(postState.feedPosts?.xMsContinuationToken)
);

export const selectFeedPostsContinuationToken = createSelector(
  [getPostState],
  (postState) => postState.feedPosts?.xMsContinuationToken
);

export const selectFocusedPost = createSelector(
  [getPostState],
  (postState) => postState.focusedPost
);

export const selectFocusedPostError = createSelector(
  [getPostState],
  (postState) => postState.focusedPostError
);

export const selectLoadingFocusedPost = createSelector(
  [getPostState],
  (postState) => postState.loadingFocusedPost
);

export const selectOpenGraphMetaTags = createSelector(
  [getPostState],
  (postState) => postState.openGraphMetaTags
);

export const selectLoadingOpenGraphMetaTags = createSelector(
  [getPostState],
  (postState) => postState.loadingOpenGraphMetaTags
);

export const selectOpenGraphMetaTagsError = createSelector(
  [getPostState],
  (postState) => postState.fetchingOpenGraphMetaTagsError
);

export const selectFeedPostsMyRooms = createSelector(
  [getPostState],
  (postState) => postState.feedPostsMyRooms?.data
);

export const selectFeedPostsMyRoomsError = createSelector(
  [getPostState],
  (postState) => postState.feedPostsMyRoomsError
);

export const selectLoadingFeedPostsMyRooms = createSelector(
  [getPostState],
  (postState) => postState.loadingFeedPostsMyRooms
);

export const selectHasMoreFeedPostsMyRooms = createSelector(
  [getPostState],
  (postState) => Boolean(postState.feedPostsMyRooms?.xMsContinuationToken)
);

export const selectFeedPostsContinuationTokenMyRooms = createSelector(
  [getPostState],
  (postState) => postState.feedPostsMyRooms?.xMsContinuationToken
);

export const selectOpenMovePostDialog = createSelector(
  [getPostState],
  (postState) => postState.openMovePostDialog
);
export const selectPostToMove = createSelector(
  [getPostState],
  (postState) => postState.postToMove
);
